///THIS DIRECTIVE CALLS A callback METHOD WHEN THIS ELEMENT BECOMES VISIBLE TO THE USER

const intersectionObserverDirective = {
	mounted(el, binding) {
		// additional options can be passed to the directive, otherwise use the default options
		const options = binding.value.options || {
			root: null, // use the viewport as the root
			threshold: 0.5,
		};

		// Create an IntersectionObserver and start observing the element
		const observer = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					// if we defined additional options then use callback, otherwise use the value as the callback function
					if (binding.value.callback) {
						binding.value.callback(observer);
					} else {
						binding.value(observer);
					}
				}
			});
		}, options);
		observer.observe(el);

		// Store the observer on the element so it can be disconnected later
		el._intersectionObserver = observer;
	},

	// Called when the bound element is unbinded from the directive
	unmounted(el) {
		// Disconnect the IntersectionObserver when the element is removed
		if (el._intersectionObserver) {
			el._intersectionObserver.disconnect();
			delete el._intersectionObserver;
		}
	},
};

export default intersectionObserverDirective;
